import Vue from 'vue'
import strings from '@/strings'
import router from '@/router'
import qs from 'qs'
import storage from '@/utils/storage'
import EventBus from 'login/EventBus'
import i18n from '@/i18n'

const proto = Vue.prototype

export default {
  _toLower(text) {
    if (text) {
      return text.toString().toLowerCase()
    } else {
      return ''
    }
  },
  getClosestVueParent($parent, cssClass) {
    if (!$parent || !$parent.$el) {
      return false
    }
    if ($parent._uid === 0) {
      return false
    }
    if ($parent.$el.classList.contains(cssClass)) {
      return $parent
    }
    return this.getClosestVueParent($parent.$parent, cssClass)
  },
  getJwtClaim(token, key) {
    let claim = token ? this.parseJWTToken(token)[key] : null
    return claim
  },
  parseJWTToken(token) {
    let base64Url = token.split('.')[1]
    let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
    let jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
    }).join(''))
    return JSON.parse(jsonPayload)
  },
  debounce(func, params, delay, timeOut) {
    let args = params ? params : arguments
    let callFunction = function () {
      func.apply(null, [args])
    }
    if (timeOut) {
      clearTimeout(timeOut)
    }
    let timeOutId = setTimeout(() => {
      callFunction()
    }, delay)
    return timeOutId
  },
  checkFeatureInRoute(routeFeatures, loadedFeatures) {
    if (routeFeatures) {
      let allow = false
      Object.entries(routeFeatures).forEach((feature) => {
        if (loadedFeatures[feature[0]]) {
          allow = true
        }
      })
      return allow
    } else {
      return true
    }
  },
  concatArrayWithComma(array) {
    if (Array.isArray(array)) {
      if (array.length === 1) {
        return array[0]
      }
      var currentLocation = proto.$languages().locale
      var currentLanguage = proto.$languages().messages[currentLocation]
      var and = currentLanguage.and.toLowerCase()
      return [array.slice(0, -1).join(', '), array.slice(-1)[0]].join(array.length < 2 ? '' : ` ${and} `)
    } else {
      return ''
    }
  },
  isPresentDay(date) {
    let onlyDate = date.clone().startOf('day').isSame(proto.$moment().startOf('day'))
    return onlyDate
  },
  handleDownload(blob, filename) {
    const url = URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = filename
    a.click()
    URL.revokeObjectURL(url);
  },
  getFileName(contentDisposition) {
    return contentDisposition.split(';').find(c => c.includes('filename=')).replace('filename=', '').trim()
  },
  sortByKey(key, order) {
    return function (a, b) {
      if (a[key] === null) {
        return order === 'desc' ? -1 : 1
      }
      if (b[key] === null) {
        return order === 'desc' ? 1 : -1
      }
      if (a[key] > b[key]) {
        return order === 'desc' ? -1 : 1
      }
      if (b[key] > a[key]) {
        return order === 'desc' ? 1 : -1
      }
      return 0
    }
  },
  regexDomain(domains, userEmail, hasBookingForGuests, hasBookingForAnotherPerson) {
    if (!hasBookingForGuests) {
      return new RegExp(domains.join(['$|']) + '$')
    } else if (hasBookingForGuests && !hasBookingForAnotherPerson) {
      return new RegExp(`${userEmail}|^((?!${domains.join(['|'])}).)*$`)
    } else {
      return false
    }
  },
  regexUuid(id) {
    if (id) {
      const regexExp = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i
      return regexExp.test(id)
    }
    return false;
  },
  convertToHours(obj) {
    return Math.round(obj / 60)
  },
  convertToMinutes(obj) {
    return Math.round(obj * 60)
  },
  convertSpecificTimeFromTimeZoneToLocalZone(timeZoneId, time) {
    if (!timeZoneId || !time) return null
    let currentLocalDateTime = this.getCurrentDate()
    let timeDiff = this.getDifferenceInHoursBetweenLocalAndTimeZone(timeZoneId)
    return proto.$moment(currentLocalDateTime + ' ' + time).add(timeDiff, 'hours').format('HH:mm')
  },
  getDifferenceInHoursBetweenLocalAndTimeZone(timeZoneId) {
    if (!timeZoneId) return null
    let localOffset = proto.$moment().utcOffset()
    let zoneOffset = proto.$moment().tz(timeZoneId + '').utcOffset()
    let diffOffset = this.convertToHours(localOffset - zoneOffset)

    return diffOffset
  },
  hasValueInArray(array) {
    return array && array.length > 0
  },
  removeItemFromArray(array, value) {
    const index = array.indexOf(value);

    if (index > -1) {
      array.splice(index, 1);
    }

    return array;
  },
  hasValueInMap(map) {
    return map && map.size > 0
  },
  nowIsAfterThan(hour) {
    return proto.$moment(proto.$moment(), proto.$moment.HTML5_FMT.TIME).isAfter(proto.$moment(hour, proto.$moment.HTML5_FMT.TIME))
  },
  nowIsEqualThan(hour) {
    return proto.$moment(hour, proto.$moment.HTML5_FMT.TIME).format('hh:mm') === proto.$moment(proto.$moment(), proto.$moment.HTML5_FMT.TIME).format('hh:mm')
  },
  isAfterThanNow(hour) {
    return proto.$moment(hour, proto.$moment.HTML5_FMT.TIME).isAfter(proto.$moment(proto.$moment(), proto.$moment.HTML5_FMT.TIME))
  },
  isAfterThan(hour1, hour2) {
    return proto.$moment(hour1, proto.$moment.HTML5_FMT.TIME).isAfter(proto.$moment(hour2, proto.$moment.HTML5_FMT.TIME))
  },
  dateIsEqualThan(date1, date2) {
    return proto.$moment(date1, proto.$moment.HTML5_FMT.DATE).format('YYYY-MM-DD') === proto.$moment(date2, proto.$moment.HTML5_FMT.DATE).format('YYYY-MM-DD')
  },
  dateIsBeforeThan(date1, date2) {
    return proto.$moment(date1, proto.$moment.HTML5_FMT.DATE).isBefore(proto.$moment(date2, proto.$moment.HTML5_FMT.DATE))
  },
  dateIsBeforeOrEqualThan(date1, date2) {
    return proto.$moment(date1, proto.$moment.HTML5_FMT.DATE).format('YYYY-MM-DD') === proto.$moment(date2, proto.$moment.HTML5_FMT.DATE).format('YYYY-MM-DD') || proto.$moment(date1, proto.$moment.HTML5_FMT.DATE).isBefore(proto.$moment(date2, proto.$moment.HTML5_FMT.DATE))
  },
  dateIsEqualOrAfterThan(date1, date2) {
    return proto.$moment(date1, proto.$moment.HTML5_FMT.DATE).format('YYYY-MM-DD') === proto.$moment(date2, proto.$moment.HTML5_FMT.DATE).format('YYYY-MM-DD') || proto.$moment(date1, proto.$moment.HTML5_FMT.DATE).isAfter(proto.$moment(date2, proto.$moment.HTML5_FMT.DATE))
  },
  dateWeekIsEqualThan(date1, date2) {
    const dateWeek1 = this.getUtcMidnightTime(date1).isoWeek()
    const dateWeek2 = this.getUtcMidnightTime(date2).isoWeek()

    return dateWeek1 === dateWeek2
  },
  dateMonthIsEqualThan(date1, date2) {
    const dateMonth1 = this.getUtcMidnightTime(date1).month()
    const dateMonth2 = this.getUtcMidnightTime(date2).month()

    return dateMonth1 === dateMonth2
  },
  getPreviousDayFromDate(date) {
    return proto.$moment(date).subtract(1, 'day').format(proto.$moment.HTML5_FMT.DATE)
  },
  sumHourIsAfterMidnight(date, fullStartDate, maximumBookingInterval) {
    let dateCompare = proto.$moment(date).set({ hour: 23, minute: 59, second: 59 }).format()
    let finish = proto.$moment(fullStartDate).add(maximumBookingInterval, 'minutes')
    return finish.isSameOrAfter(dateCompare)
  },
  finishWorkingTimeIsValid(start, defaultEnd, maximumBookingInterval) {
    let startMoment = proto.$moment(start, proto.$moment.HTML5_FMT.TIME)
    let defaultFinish = proto.$moment(defaultEnd, proto.$moment.HTML5_FMT.TIME)
    let bookingInterval = defaultFinish.diff(startMoment, 'minutes')
    return bookingInterval <= maximumBookingInterval
  },
  bookingForLabel(hasBookingForGuests, hasBookingForAnotherPerson) {
    if (hasBookingForGuests && hasBookingForAnotherPerson) {
      return 'employeeOrVisitorEmail'
    } else if (hasBookingForAnotherPerson) {
      return 'nameOrEmail'
    } else if (hasBookingForGuests) {
      return 'visitorEmail'
    }
  },
  getBookingAntecedenceLimitDate(initialSettings, siteConfig) {
    const bookingAntecedenceLimit = siteConfig ? siteConfig.bookingAntecedenceLimit : initialSettings.bookingAntecedenceLimit
    return proto.$moment().add(bookingAntecedenceLimit, 'days').format(proto.$moment.HTML5_FMT.DATE)
  },
  getBookingSettingsLimitDate(limitDate = 0) {
    return proto.$moment().add(limitDate, 'days').format(proto.$moment.HTML5_FMT.DATE)
  },
  getCurrentDate() {
    return proto.$moment().format(proto.$moment.HTML5_FMT.DATE)
  },
  getNextEnabledDate(date, dayOfMinDate, enabledDays) {
    const weekDate = proto.$moment(date).week()
    const nextEnabledDay = enabledDays.find(day => day >= dayOfMinDate)

    if (nextEnabledDay) {
      return proto.$moment(date.day(nextEnabledDay)).format(proto.$moment.HTML5_FMT.DATE)
    }

    const nextWeek = weekDate + 1
    return proto.$moment(date.week(nextWeek).day(enabledDays[0])).format(proto.$moment.HTML5_FMT.DATE)
  },
  getNextDay() {
    return proto.$moment().add(1, 'day').format(proto.$moment.HTML5_FMT.DATE)
  },
  getMidnightTime(date) {
    return proto.$moment(date).set({ hour: 23, minute: 59, second: 59 })
  },
  getUtcMidnightTime(date) {
    return proto.$moment.utc(date).set({ hour: 23, minute: 59, second: 59 })
  },
  getTimeInUtc(time) {
    const timeZone = proto.$moment.tz.guess()
    const localTime = proto.$moment.tz(time, "HH:mm", timeZone);

    return localTime.utc().format("HH:mm");
  },
  getDateTwelveMonthsAgo() {
    return proto.$moment().subtract(1, 'year').date(1).format(proto.$moment.HTML5_FMT.DATE)
  },
  dateIsToday(date) {
    return proto.$moment(date).isSame(new Date(), 'day')
  },
  getWeekRangeByLimit(date, startLimit, endLimit) {
    const week = proto.$moment(date).week()
    const firstDateOfWeek = proto.$moment().week(week).day(0)
    const lastDateOfWeek = proto.$moment().week(week).day(6)
    const minDateValid = this.dateIsBeforeOrEqualThan(firstDateOfWeek, startLimit) ? startLimit : firstDateOfWeek
    const maxDateValid = this.dateIsBeforeOrEqualThan(endLimit, lastDateOfWeek) ? endLimit : lastDateOfWeek

    return { start: minDateValid, end: maxDateValid }
  },
  getMonthRangeByLimit(date, startLimit, endLimit) {
    const month = proto.$moment(date).month()
    const firstDateOfMonth = proto.$moment().month(month).startOf('month').format()
    const lastDateOfMonth = proto.$moment().month(month).endOf('month').format()
    const minDateValid = this.dateIsBeforeOrEqualThan(firstDateOfMonth, startLimit) ? startLimit : firstDateOfMonth
    const maxDateValid = this.dateIsBeforeOrEqualThan(endLimit, lastDateOfMonth) ? endLimit : lastDateOfMonth

    return { start: minDateValid, end: maxDateValid }
  },
  waitFor(milliseconds) {
    return new Promise((resolve) => setTimeout(resolve, milliseconds));
  },
  async exponentialBackoffProgress(retries, sumTimeToWait, maxTimeToWait) {
    const timeToWait = 2 ** retries * 10;
    const newSumTimeToWait = sumTimeToWait + timeToWait

    if (newSumTimeToWait > maxTimeToWait) {
      throw 'Error';
    } else {
      return {
        timeToWait,
        newSumTimeToWait
      }
    }
  },
  convetDecToHexUnsigned(number) {
    return number.toString(16).toUpperCase()
  },

  createArray8Bits(value) {
    let bits = [];
    for (let i = value.length; i > 0; i = i - 2) {
      if (i == 1) {
        bits.push('0x0' + value.slice(i - 1, i));
        break
      }
      bits.push('0x' + value.slice(i - 2, i));
    }
    if (bits.length % 2) {
      bits.push('0x00')
    }
    return bits.reverse();
  },
  createDataPrefixWithoutTxPower(uuid, major, minor) {
    let uuidNoDash = uuid.replace(/-/g, "");
    let iBeaconId = ['0x02', '0x15'];

    return iBeaconId.concat(
      this.createArray8Bits(uuidNoDash, false),
      this.createArray8Bits(this.convetDecToHexUnsigned(major), true),
      this.createArray8Bits(this.convetDecToHexUnsigned(minor), true)
    )
  },
  concatTxPowerMonitoring(array) {
    let txPower = ['0xC8'];
    return new Uint8Array(array.concat(txPower))
  },
  concatTxPowerPsensor(array) {
    let txPower = ['0xC5'];
    return new Uint8Array(array.concat(txPower))
  },
  enableCheckIn(booking, siteConfig, initialSettings, bookingType) {
    let checkinStartTolerance = this.getToleranceToCheckinByType(siteConfig, initialSettings, bookingType)

    const startDateWithTolerance = proto.$moment(booking.start).subtract(checkinStartTolerance, 'm')
    const endDate = proto.$moment(booking.finish)
    const currentDate = proto.$moment()

    const somethingIsLoading = booking.checkinLoading === true || booking.cancelLoading === true

    const canCheckin = booking.status === strings.checkInStatus.booked && !somethingIsLoading && currentDate.isBetween(startDateWithTolerance, endDate)

    return canCheckin
  },
  getToleranceToCheckinByType(siteConfig, initialSettings, bookingType) {
    let checkinStartTolerance = initialSettings.desks.toleranceToCheckinInMinutes;
    const config = siteConfig || initialSettings;
    switch (bookingType) {
      case strings.bookingTypeEnum.desk:
        if (config.desks.allowEarlyCheckin) {
          checkinStartTolerance += config.desks.earlyCheckinToleranceInMinutes;
        }
        break;
      case strings.bookingTypeEnum.parking:
        checkinStartTolerance = initialSettings.parkings.toleranceToCheckinInMinutes;
        if (config.parkings.allowEarlyCheckin) {
          checkinStartTolerance += config.parkings.earlyCheckinToleranceInMinutes;
        }
        break;
      case strings.bookingTypeEnum.locker:
        checkinStartTolerance = initialSettings.lockers.toleranceToCheckinInMinutes;
        if (config.lockers.allowEarlyCheckin) {
          checkinStartTolerance += config.lockers.earlyCheckinToleranceInMinutes;
        }
        break;
      default:
        break;
    }

    return checkinStartTolerance;
  },
  getToleranceToBookByType(settings, bookingType) {
    let bookTolerance = settings.desks.toleranceToBookInMinutes

    if (strings.bookingTypeEnum.desk === bookingType) {
      bookTolerance = settings.desks.toleranceToBookInMinutes
    } else if (strings.bookingTypeEnum.parking === bookingType) {
      bookTolerance = settings.parkings.toleranceToBookInMinutes
    } else if (strings.bookingTypeEnum.locker === bookingType) {
      bookTolerance = settings.lockers.toleranceToBookInMinutes
    }

    return bookTolerance;
  },
  enableCheckOut(booking) {
    const somethingIsLoading = booking.checkinLoading === true || booking.checkoutLoading === true
    return booking.status === strings.checkInStatus.checkedIn && !somethingIsLoading
  },
  canCancel(booking) {
    const somethingIsLoading = booking.checkinLoading === true || booking.cancelLoading === true
    return booking.status === 'booked' && !somethingIsLoading
  },
  validateBookingTime(settings, siteConfig, date, start, end, bookingType) {
    let dateErrors = []

    const setting = siteConfig ? siteConfig : settings

    const {
      bookingAntecedenceLimit,
      maximumBookingInterval,
      minimumBookingInterval
    } = setting

    const now = proto.$moment
    const formDates = this.getFullDate(date, start, end)

    if (formDates.startDate.isValid() && formDates.finishDate.isValid()) {
      if (formDates.finishDate.diff(formDates.startDate, 'minutes') / minimumBookingInterval < 1) {
        dateErrors.push('requestedTimeIntervalLessThanLimit')
      }

      if (formDates.finishDate.diff(formDates.startDate, 'minutes') / maximumBookingInterval > 1) {
        dateErrors.push('requestedTimeIntervalGreaterThanLimit')
      }

      if (formDates.startDate > (now().add(bookingAntecedenceLimit, 'days'))) {
        dateErrors.push('requestedDateGreaterThanTheLimit')
      }
      if (formDates.startDate.isBefore(now(), 'day')) {
        dateErrors.push('requestedDateLessThanCurrentDate')
      }
      if (formDates.startDate < (now().subtract(this.getToleranceToBookByType(settings, bookingType), 'minutes'))) {
        dateErrors.push('requestedTimeLessThanCurrentTime')
      }
    } else {
      dateErrors.push('invalidDate')
    }

    return dateErrors
  },
  validateBookingDate(settings, siteConfig, date) {
    const setting = siteConfig ? siteConfig : settings

    const {
      bookingAntecedenceLimit,
    } = setting

    const now = proto.$moment
    const formatDate = proto.$moment(date, 'YYYY-MM-DD')
    if (formatDate.isValid()) {
      if (formatDate.isBefore(now(), 'day')) {
        return 'requestedDateLessThanCurrentDate'
      }
      if (formatDate > (now().add(bookingAntecedenceLimit, 'days'))) {
        return 'requestedDateGreaterThanTheLimit'
      }
    } else {
      return 'invalidDate'
    }
  },
  getFullDate(date, start, finish) {
    const fullStartDate = date + ' ' + start
    const fullEndDate = date + ' ' + finish
    const startDate = proto.$moment(fullStartDate, 'YYYY-MM-DD HH:mm')
    const finishDate = proto.$moment(fullEndDate, 'YYYY-MM-DD HH:mm')
    return { startDate, finishDate }
  },
  dispatchEventOnComponentTree(context, componentName, eventName, ...rest) {
    let parent = context.$parent || context.$root
    let name = parent.$options.name

    while (parent && (!name || name !== componentName)) {
      parent = parent.$parent
      if (parent) {
        name = parent.$options.name

      }
    }

    if (parent) {
      parent.$emit.apply(parent, [eventName].concat(rest))
    }
  },
  checkIfArrayHasFilterOptionsInterception(array, filters) {
    return filters.every(filter => {
      return array.includes(filter)
    })
  },
  checkIfArrayHasFilterOptionsUnion(array, filters) {
    return filters.some(filter => {
      return array.includes(filter)
    })
  },
  getItemDisplay(state, objectKey) {
    return state.name ? state.name : state[objectKey]
  },
  capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1)
  },
  generateHashFromString(str) {
    return str.split('').reduce((prevHash, currVal) =>
      (((prevHash << 5) - prevHash) + currVal.charCodeAt(0)) | 0, 0);
  },
  getLastPathUrl() {
    let url = router.history.current.path.split('/')
    return url[url.length - 1]
  },
  generateQueryString(filters, isFile) {
    let config = {
      responseType: '',
      params: filters,
      paramsSerializer: (params) => {
        return qs.stringify(params, { arrayFormat: 'repeat' })
      }
    }

    if (isFile) {
      config.responseType = 'arraybuffer'
    }
    return config
  },
  formatDateTimeToUtc(date) {
    return proto.$moment(date).utc().format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z'
  },
  calculateSlots(amountOfSlotsUser, availableFrom, periodFro) {
    let amountOfSlots = parseInt(amountOfSlotsUser, 10) > parseInt(strings.restaurantBookingParams.maxSlots, 10) ? strings.restaurantBookingParams.maxSlots : amountOfSlotsUser
    let timeSlots = []
    let slot = {}
    if (periodFro && availableFrom) {
      for (let i = 0; i <= amountOfSlots - 1; i++) {
        let startSlot = proto.$moment(availableFrom, proto.$moment.HTML5_FMT.TIME).add(periodFro * i, 'minutes')
        let finishSlot = startSlot.add(periodFro, 'minutes')
        slot = {
          timeFrom: proto.$moment(availableFrom, proto.$moment.HTML5_FMT.TIME).add(periodFro * i, 'minutes').format('LT'),
          timeTo: finishSlot.format('LT')
        }
        timeSlots.push(slot)
      }
    }
    return timeSlots
  },
  checkNPS(journey) {
    var version = process.env.VUE_APP_BUILD_NUMBER
    let journeySession = storage.getFromLocalStorage('NPSVersion')
    if (!journeySession || journeySession < version) {
      storage.saveToLocalStorage('NPSCurrentJourney', {
        journey: journey,
        version
      })
    }
  },
  checkPendingNPSAndOpen() {
    let currentJourney = storage.getFromLocalStorage('NPSCurrentJourney')
    if (currentJourney) {
      EventBus.publish("openNPS")
    }
  },
  getTranslatedMessage(messageKey, messageValues = []) {
    const locale = proto.$languages().locale
    const messages = proto.$languages().messages[locale]

    return messages[messageKey]?.format(messageValues)
  },
  getPlaceName(place) {
    return `${place.name}${place.active === false ? ` (${i18n.t('disabled')})` : ''}`;
  }
}
